import * as _ from 'underscore';
import { Router } from '@angular/router';
import { DeleteDialogComponent } from '..';
import { FormControl } from '@angular/forms';
import { ENTER, COMMA, X } from '@angular/cdk/keycodes';
import { MasterHelper } from 'src/app/core/utilities';
import { AlertDialogModel } from 'src/app/core/models/view-model';
import { RegulationService } from 'src/app/core/services/regulation';
import { ItemInfoDto } from 'src/app/core/models/rulebook/item.info-dto';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { GDPRService } from './../../../core/services/rulebook/gdpr.service';
import { UserProfile } from './../../../core/models/user/user-profile.model';
import { SessionService } from './../../../core/services/auth/session.service';
import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { AdditionalFilter } from 'src/app/core/models/rulebook/additional-filter';
import { MAT_DIALOG_DATA,  MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ToastViewModel } from './../../../core/models/view-model/toast-view-model';
import { RegulationDetail } from 'src/app/core/models/regulation/regulation-detail';
import { LinkedRegulationInfo } from 'src/app/core/models/regulation/linked-regulation-info';
import { SimilarRegulationFilter } from 'src/app/core/models/regulation/similar-regulation-filter';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { AssessmentDialogComponent } from '../../shared/assessment-dialog/assessment-dialog.component';
import { SimilarRegulationDataModel, SimilarRegulationModel } from 'src/app/core/models/regulation/similar-regulation-model';
import { FileType } from 'src/app/core/enums/user/file-type';
import { HttpErrorResponse } from '@angular/common/http';
import { UpdateImpactAssessmentModel } from 'src/app/core/models/impact-assessment/update-impact-assessment-model';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { RegulationColumnModel } from 'src/app/core/models/regulation/regulation-close-status-model';
import { bulkcloseEvidanceInputModel, closeEvidanceInputModel } from 'src/app/core/models/regulation/close-evidance-input-model';
import { CloseEvidanceDocumentModel } from 'src/app/core/models/regulation/close-Evidance-document-model';
import { UserService } from 'src/app/core/services/user';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-change-viewer-dialog',
  templateUrl: './change-viewer-dialog.component.html',
  styleUrls: ['./change-viewer-dialog.component.scss'],
})
export class ChangeViewerDialogComponent implements OnInit {
  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;

  toastModel: ToastViewModel;
  isToastShow = false;
  filterType: string;
  user: UserProfile;
  isMovedToIA = false;
  isDisabled = false;
  isDelete = false;
  isDeleteDisabled = 'disabled';
  userName = '';
  searchText = '';
  linkedUpdates: SimilarRegulationModel[] = [];
  searchedlinkedUpdates: SimilarRegulationModel[] = [];
  savedJuridiction: string[] = [];
  selectedIds: number[] = [];
  similarResult: SimilarRegulationDataModel;

  searchedJuris: ItemIdModel[] = [];
  selectedJuris: ItemIdModel[] = [];
  keyCtrl = new FormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];

  totalCount = 0;
  isTableLoaded = false;
  myInnerHeight: any;
  endIndex = 0;
  filters: AdditionalFilter;
  isSelectAll = false;
  isSelectClosed = false;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  impactAssessmentDocument: Array<CloseEvidanceDocumentModel>;
  isAssessmentLoader = false;
  isReviewLoader = false;
  isImplementationLoader = false;
  isImplementationLastEdited = false;
  updateIADetails!: UpdateImpactAssessmentModel;
  isAssessmentLastEdited = false;
  isReviewLastEdited = false;
  isLoading = false;
  isFileExist:boolean=false;
  closeStatusList:Array<RegulationColumnModel>=[];
  closeEvidanceInput!: closeEvidanceInputModel;
  bulkCloseEvidanceInput!: bulkcloseEvidanceInputModel;
  @ViewChild('myFileInput') myFileInput:any;
  templateNo:number=1;

TempTabType:any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public regulationDetails: RegulationDetail,
    public dialogRef: MatDialogRef<ChangeViewerDialogComponent>, public router: Router,
    public sessionService: SessionService, public gdprService: GDPRService,
    private dialog: MatDialog,
    private regulationService: RegulationService, public userService: UserManagementService,
    private _userService:UserService,
    private _globalService: GlobalService) {
    this.impactAssessmentDocument = [];
    this.toastModel = new ToastViewModel();
    this.filterType = this.regulationDetails.filterType;
    this.user = new UserProfile();
    if (this.filterType === 'Current Actions' ) {
      this.isDisabled = true;
      this.isDelete = true;
    }
    this.filters = new AdditionalFilter();
    this.similarResult = new SimilarRegulationDataModel();
    this.getRegulationStatusList();
  }

  ngOnInit(): void {
    if (this.filterType !== 'Open' && this.filterType !== 'Current Actions') {
      this.fetchRegulationDetail();
    } else {
      let IsEditlinkedClosedId= localStorage.getItem('IsEditlinkedClosedId');
      if(IsEditlinkedClosedId == null){
        this.isDelete = false;
      }
      if(IsEditlinkedClosedId && IsEditlinkedClosedId!=="[]"){
        this.fetchRegulationDetail();
        localStorage.removeItem('IsEditlinkedClosedId')
      }
      else{
        if (this.regulationDetails.userId) {
          this.fetchUserName();
        }
        this.fetchUserProfile();
      }
    }
    this.filters.SortKey = 'id';
    this.filters.IsDesc = true;
    this.TempTabType=this.regulationDetails.TabType;
  }

  fetchRegulationDetail(): void {
    let jurisdiction:string='';
    let linkedClosedIdJurisdiction= localStorage.getItem('linkedClosedIdJurisdiction');
    if(linkedClosedIdJurisdiction && linkedClosedIdJurisdiction!=="[]"){
      jurisdiction=linkedClosedIdJurisdiction;
    }
    else{
      jurisdiction=localStorage.getItem('selectedDivision')!;
    }
    this.regulationService.getRegulationDetails(this.regulationDetails.regulationId,jurisdiction).subscribe((result: RegulationDetail) => {
      this.regulationDetails = result;
      if (this.regulationDetails.userId) {
        this.fetchUserName();
      }
      this.fetchUserProfile();
    });
  }

 getRegulationStatusList(): void {
    this.regulationService.getRegulationStatus().subscribe((result: RegulationColumnModel[]) => {
      this.closeStatusList=result;
    });
  }

  async  fetchUserProfile() {
    this.user = await this._globalService.getLoginUserData();
    this.isDeleteDisabled =
      this.filterType === 'Current Actions'
        ? 'disabled'
        : this.regulationDetails.id === 0
        ? 'disabled'
        : this.regulationDetails.userId !== this.user.externalUserId &&
          this.regulationDetails.id > 0
        ? 'disabled'
        : '';
    this.fetchJurisdiction();
  }

  fetchUserName(): void {
    this.userService.getUserName(this.regulationDetails.userId).subscribe((user: any) => {
      this.userName = user.result;
    });
  }

  async closeDialog() {
    if (!this.isDisabled) {
      if (this.selectedJuris.length === 0) {
        this.toastModel.Title = 'Warning';
        this.toastModel.Type = 'warning';
        this.toastModel.Message = 'Please select jurisdiction';
        this.isToastShow = true;
        setTimeout(() => {
          this.isToastShow = false;
        }, 3000);
      } else {
        if(this.regulationDetails.status==0){
          this.toastModel.Title = 'Warning';
          this.toastModel.Type = 'warning';
          this.toastModel.Message = 'Please select a status';
          this.isToastShow = true;
          setTimeout(() => {
            this.isToastShow = false;
          }, 3000);          
          // const item = this.closeStatusList.find((item) => item.title == "Closed - Not Applicable");
          // this.regulationDetails.status = item ? item.id : 0;
        } else {
          this.regulationDetails.jurisdiction = MasterHelper.getStringFromObjectArray(this.selectedJuris);
          this.regulationDetails.selectedLinkedIds = this.selectedIds;          
          await this.dialogRef.close(this.regulationDetails);
        }
        
      }
    }
  }

  async addImpactAssessment(id: number){
    if (!this.isDisabled) {
      if (this.selectedJuris.length === 0) {
        this.toastModel.Title = 'Warning';
        this.toastModel.Type = 'warning';
        this.toastModel.Message = 'Please select jurisdiction';
        this.isToastShow = true;
        setTimeout(() => {
          this.isToastShow = false;
        }, 3000);
      } else {
        let data: any = await this.gdprService.getTemplateNo().toPromise();
        this.templateNo = data.result;
        this.isMovedToIA = true;
        const itemInfoDto = new ItemInfoDto();
        itemInfoDto.id = id;
        itemInfoDto.screenUrl = this.router.url;
        itemInfoDto.regulationDetailId = this.regulationDetails.id;
        itemInfoDto.jurisdictions = MasterHelper.getStringArrayFromObjectArray(this.selectedJuris);
        if (this.templateNo == 4) {
          this.gdprService.moveToImpactAssessment4(itemInfoDto).subscribe((data: any) => {
            this.alertMessage(data);
          });
        }
        else if(this.templateNo == 5){
          this.gdprService.moveToImpactAssessment5(itemInfoDto).subscribe((data: any) => {
            this.alertMessage(data);
          });
        }
        else if(this.templateNo == 6){
          this.gdprService.moveToImpactAssessment6(itemInfoDto).subscribe((data:any)=>{
            this.alertMessage(data);
          })
        }
        else{
          this.gdprService.moveToImpactAssessment(itemInfoDto).subscribe((data: any) => {
            this.alertMessage(data);
          });
        }
      }
    }
  }

  alertMessage(data: any): void {
    if (data.result?.resultId > 0 && data.result.status) {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Regulation Moved to Impact Assessment';
    }else if(!data.result?.status && data.result?.message){
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message =data.result?.message
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message = 'Impact Assessment on this Change Id already exists';
    }
    this.isToastShow = true;
    setTimeout(() => {
      this.isMovedToIA = false;
      this.isToastShow = false;
      if (data.result?.resultId > 0) {
        window.location.href = '/impact-assessment/details/impact/'+this.templateNo+'/' + data.result.resultId;
        this.saveOnBrowser('_iaid', data.result.resultId);
      }
    }, 3500);
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchJurisdiction(): void {
    this.userService.getUserJurisdictions().subscribe((result: ItemIdModel[]) => {
      this.searchedJuris = result;
      if (this.regulationDetails.jurisdiction) {
        const jurisArr = this.regulationDetails.jurisdiction.split(',');
        jurisArr.forEach(element => {
          if (!result.some(a => a.name === element) && this.filterType !== 'Current Actions') {
            this.isDisabled = true;
            this.isDelete = true;
            this.savedJuridiction.push(element);
          } else if (this.selectedJuris.length < 1) {
            this.selectedJuris.push({ id: 0, name: element });
          }
        });
      }
      if (this.searchedJuris && this.searchedJuris.length > 0 && this.selectedJuris.length === 0) {
        let division:any;
        let linkedClosedIdJurisdiction= localStorage.getItem('linkedClosedIdJurisdiction');
        if(linkedClosedIdJurisdiction && linkedClosedIdJurisdiction!=="[]"){
          division=linkedClosedIdJurisdiction;
          localStorage.removeItem('linkedClosedIdJurisdiction')
        }
        else{
          //division=localStorage.getItem('selectedDivision');
          division=this.user.lastUsedJurisdictionId;
        }
        if(division){
          var filterDivision=this.searchedJuris.filter(s => s.id.toString()==division);
          if(filterDivision && filterDivision.length>0){
            this.selectedJuris.push(filterDivision[0]);
          }
        }
        else{
          this.selectedJuris.push(this.searchedJuris[0]);
        }

       // this.selectedJuris.push(this.searchedJuris[0]);
      }
      if (this.regulationDetails.id === 0 && this.regulationDetails.similarIndex && this.selectedJuris.length > 0) {
        this.fetchSimilarRegulation();
      } else {
        this.isTableLoaded = true;
      }
      this.fetchCloseEvidanceDocuments();
    });
  }

  openDeleteDialog(): void {
    if (this.isDeleteDisabled === '') {
      const alertDialogModel = new AlertDialogModel();
      alertDialogModel.HeadingText = 'Delete Status';
      alertDialogModel.BodyText = 'Are you sure you want to delete this status?';
      alertDialogModel.ActionButtonText = 'Delete';
      alertDialogModel.IsAction = true;

      const dialogRef = this.dialog.open(DeleteDialogComponent, {
        width: '450px',
        data: alertDialogModel,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'Delete Status') {
          this.deleteRegulation();
        }
      });
    }
  }

  deleteRegulation(): void {
    let jurisdiction = MasterHelper.getStringFromObjectArray(this.selectedJuris);
    this.regulationService.deleteClosedRegulation(this.regulationDetails.id, this.regulationDetails.regulationId, jurisdiction).subscribe((data: any) => {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = data.message;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 3000);
      this.dialogRef.close('Delete Regulation Details');
    });
  }

  onChange(): void {
    this.isTableLoaded = false;
    this.fetchSimilarRegulation();
  }

  fetchSimilarRegulation(): void {
    const similarFilter = new SimilarRegulationFilter();
    similarFilter.similarIndex = this.regulationDetails.similarIndex;
    similarFilter.jurisdiction = MasterHelper.getStringArrayFromObjectArray(this.selectedJuris);
    this.regulationService.getSimilarRegulation(similarFilter).subscribe((result: SimilarRegulationDataModel) => {
      this.similarResult = result;
      this.linkedUpdates = result.similarRegulations;
      this.searchedlinkedUpdates = result.similarRegulations;
      this.totalCount = result.similarRegulations ? result.similarRegulations.length : 0;
      this.isTableLoaded = true;
      this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
      if(this.selectedJuris.length>0){
        this.fetchCloseEvidanceDocuments();
      }
      else{
        this.impactAssessmentDocument =[];
      }

    });
  }

  sortItem(key: string): void {
    this.filters.IsDesc = !this.filters.IsDesc;
    this.filters.SortKey = key;
    this.linkedUpdates = this.filters.IsDesc ? _.sortBy(this.linkedUpdates, [key]).reverse()
      : _.sortBy(this.linkedUpdates, [key]);
  }

  onEnterSearchKeys(event: any): void {
    if (this.searchText.length > 1) {
      this.filterData();
    }
    if (event.keyCode === 13) {
      this.filterData();
    }
    if (event.keyCode === 8 && this.searchText.length < 2) {
      this.filterData();
    }
  }

  filterData(): any {
    if (this.searchText) {
      this.linkedUpdates = this.linkedUpdates.filter(option => option.id.toString().toLowerCase().includes(this.searchText.toLowerCase())
        || option.regulator.toString().toLowerCase().includes(this.searchText.toLowerCase())
        || option.pubType.toString().toLowerCase().includes(this.searchText.toLowerCase())
        || option.title.toString().toLowerCase().includes(this.searchText.toLowerCase()));
    } else {
      this.linkedUpdates = this.searchedlinkedUpdates;
    }
    this.totalCount = this.linkedUpdates.length;
    this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
  }

  selectAllItem(event: any): void {
    this.selectedIds = [];
    if (event.target.checked === true) {
      if (this.linkedUpdates) {
        this.linkedUpdates.forEach(element => {
          this.selectedIds.push(element.id);
        });
      }
      this.isSelectAll = true;
      this.isSelectClosed = true;
    } else {
      this.isSelectAll = false;
      this.isSelectClosed = false;
    }
  }

  selectAllClosed(event: any): void {
    if (event.target.checked === true) {
      if (this.similarResult.closedIds) {
        this.similarResult.closedIds.forEach(element => {
          this.selectedIds.push(element);
        });
      }
      this.isSelectClosed = true;
    } else {
      if (this.similarResult.closedIds) {
        this.similarResult.closedIds.forEach(element => {
          this.selectedIds.splice(this.selectedIds.indexOf(element), 1);
        });
      }
      this.isSelectClosed = false;
    }
    this.isSelectAll = this.linkedUpdates.length === this.selectedIds.length ? true : false;
  }

  selectItem(event: any, id: number): void {
    if (event.target.checked === true) {
      this.selectedIds.push(id);
    } else {
      const index = (this.selectedIds as number[]).indexOf(id);
      if (index >= 0) {
        (this.selectedIds as number[]).splice(index, 1);
      }
    }
    this.isSelectAll = this.linkedUpdates.length === this.selectedIds.length ? true : false;
    const findAllId = [];
    if (this.similarResult.closedIds) {
      this.similarResult.closedIds.forEach(element => {
        const index = (this.selectedIds as number[]).indexOf(element);
        if (index >= 0) {
          findAllId.push(element);
        }
      });
    }
    this.isSelectClosed = findAllId.length === this.similarResult.closedIds.length ? true : false;
    this.fetchCloseEvidanceDocuments();
  }

  checkSelectedItem(id: number): boolean {
    if (this.selectedIds.length === 0) {
      return false;
    } else {
      const result = this.selectedIds.find(a => +a === +id);
      return result ? true : false;
    }
  }

  getLinkedInfo(id: number): void {
    var jurisdiction = MasterHelper.getStringFromObjectArray(this.selectedJuris);
    this.regulationService.getLinkedInfo(id,jurisdiction).subscribe((result: LinkedRegulationInfo) => {
      if (result) {
        this.regulationDetails.title = result.title;
        this.regulationDetails.type = result.pubType;
        this.regulationDetails.id=result.regulationDetailId;
        this.regulationDetails.regulationId=id;
      }
    });
  }

  openAssessmentPopup(id: number): void {
    const dialogRef = this.dialog.open(AssessmentDialogComponent, {
      width: '1800px',
      height: '870px',
      data: id
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  openEditPopup(id: string): void {
    const regDetails = new RegulationDetail();
    let isContain=id.includes('|')
    if(isContain){
      let arr=id.split('|');
      if(arr && arr.length>1){
        regDetails.regulationId=Number(arr[1]);
        let filterDivision=this.searchedJuris.filter(s => s.name.toString()==arr[0]);
          if(filterDivision && filterDivision.length>0){
            localStorage.setItem('linkedClosedIdJurisdiction', filterDivision[0].id.toString());
          }
      }
    }
    else{
      regDetails.regulationId =Number(id);
    }
    regDetails.filterType = 'Current Actions';
    localStorage.setItem('IsEditlinkedClosedId', "true");
    const dialogRef = this.dialog.open(ChangeViewerDialogComponent, {
      width: '1000px',
      data: regDetails,
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }
  uploadEvidenceAssessment(): void {
    if(this.selectedJuris.length>0){
      const fileInput = document.getElementById('uploadEviAssessment') as HTMLElement;
      fileInput.click();
    }
    else{
      this.imageAlertMessage('warning', "Please select a division!");
    }

  }
  handleFileInput(files: FileList): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      if(this.selectedIds && this.selectedIds.length>0){
        this.BulkUploadFileToActivity(files[i], FileType.Assessment);
      }
      else{
        this.uploadFileToActivity(files[i], FileType.Assessment);
      }
    }
    this.myFileInput.nativeElement.value = '';
  }
  uploadFileToActivity(fileToUpload: any, fileType: FileType): void {
    let jurisdiction = MasterHelper.getStringFromObjectArray(this.selectedJuris);
    this.isAssessmentLoader = true;
    this.regulationService.uploadEvidence(fileToUpload, fileType, this.regulationDetails.regulationId,jurisdiction).subscribe((data: any) => {
      this.fetchCloseEvidanceDocuments(fileType);
      this.isAssessmentLoader = false;
      this.updateSectionLastEdited('Assessment');
    }, (err: HttpErrorResponse) => {
      this.isAssessmentLoader = false;
      this.isReviewLoader = false;
      this.isImplementationLoader = false;
      this.imageAlertMessage('warning', 'File not uploaded, please check your file');
      setTimeout(() => {
      }, 1000);
    });
  }
  BulkUploadFileToActivity(fileToUpload: any, fileType: FileType): void {
    let jurisdiction = MasterHelper.getStringFromObjectArray(this.selectedJuris);
    this.isAssessmentLoader = true;
    const Ids=this.getAllIdsWithLinkedId();
    this.regulationService.uploadEvidenceForBulkClose(fileToUpload, fileType, Ids,jurisdiction).subscribe((data: any) => {
      this.fetchCloseEvidanceDocuments(fileType);
      this.updateSectionLastEdited('Assessment');
    }, (err: HttpErrorResponse) => {
      this.isAssessmentLoader = false;
      this.imageAlertMessage('warning', 'File not uploaded, please check your file');
      setTimeout(() => {
      }, 1000);
    });
  }
  fetchCloseEvidanceDocuments(fileType?: FileType): void {
    this.isAssessmentLoader = true;
    let Ids;
    if(this.selectedIds && this.selectedIds.length>0){
      Ids=this.getAllIdsWithLinkedId();
    }
    else{
      Ids=this.regulationDetails.regulationId.toString()
    }
    let jurisdiction = MasterHelper.getStringFromObjectArray(this.selectedJuris);
    this.regulationService.getImpactAssessmentDocuments( Ids, jurisdiction).subscribe((result: CloseEvidanceDocumentModel[]) => {

      this.impactAssessmentDocument = result;
      if(this.impactAssessmentDocument.length>0){
        this.isFileExist=true;
      }
      this.isAssessmentLoader = false;
    });
  }

  updateSectionLastEdited(filter: string): void {
    this.isAssessmentLastEdited = true;
  }
  downloadDocument(id: number, fileName: string, extension: string, fileType: string,fileUrl:string): void {
    this.isAssessmentLoader = true;
    this.regulationDetails.FileName=fileName;
    this.regulationDetails.FileExtension=extension;
    this.regulationDetails.FileType=fileType;
    this.regulationDetails.FileUrl=fileUrl;
    this.regulationService.downloadEvidence(this.regulationDetails.regulationId,this.regulationDetails)
      .subscribe((data: any) => {
        this.isAssessmentLoader = false;
        // tslint:disable-next-line:one-variable-per-declaration
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `${fileName}${extension}`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      });
  }
  openDeleteModel(id: number, jurisdictionId:number,fileType: string, extension: string,fileName: string,fileUrl:string): void {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to delete?',
        title: 'Delete Document',
        btnText: 'Delete',
      }
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        if(this.selectedIds && this.selectedIds.length>0){
          this.removeBulkCloseEvidanceDocuments(id, fileType,extension,fileName,fileUrl,jurisdictionId);
        }
        else{
          this.removeCloseEvidanceDocuments(id, fileType,extension,fileName,fileUrl,jurisdictionId);
        }
      }
    });
  }
  removeCloseEvidanceDocuments(id: number, fileType: string,extension: string,fileName: string,fileUrl:string,jurisdictionId:number): void {
    this.isAssessmentLoader = true;
    if(this.impactAssessmentDocument.length>0){
      this.closeEvidanceInput={FileExtension:extension,FileName:fileName,FileUrl:fileUrl,FileType:"1",Id:this.regulationDetails.regulationId,JurisdictionId:jurisdictionId};

    }
    this.regulationService.DeleteCloseEvidenceDocument(id,this.closeEvidanceInput).subscribe((data: any) => {
      this.isAssessmentLoader = false;
      this.fetchCloseEvidanceDocuments(FileType.Assessment);
      if (data.result) {
        this.imageAlertMessage('success', data.result);
      }
    });
  }
  removeBulkCloseEvidanceDocuments(id: number, fileType: string,extension: string,fileName: string,fileUrl:string,jurisdictionId:number): void {
    this.isAssessmentLoader = true;
    const Ids=this.getAllIdsWithLinkedId();
    if(this.impactAssessmentDocument.length>0){
      this.bulkCloseEvidanceInput={FileExtension:extension,FileName:fileName,FileUrl:fileUrl,FileType:"1",Id:Ids,JurisdictionId:jurisdictionId};
    }
    this.regulationService.DeleteBulkCloseEvidenceDocument(id,this.bulkCloseEvidanceInput).subscribe((data: any) => {
      this.isAssessmentLoader = false;
      this.fetchCloseEvidanceDocuments(FileType.Assessment);
      if (data.result) {
        this.imageAlertMessage('success', data.result);
      }
    });
  }
  imageAlertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }
  getAllIdsWithLinkedId(){
    let Ids=this.selectedIds.toString();
    let FilteiId=this.selectedIds.filter((obj) => {
      return obj === this.regulationDetails.regulationId;
    });
    if(FilteiId && FilteiId.length==0){
      Ids=Ids+','+this.regulationDetails.regulationId;
    }
    return Ids;
  }

}
